import { useEffect, useState, useCallback } from 'react';
import {
  Flex
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faSpinner, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/auth';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Helmet } from 'react-helmet-async';
import style from './style.module.scss';
import { InputsInfosPages } from '../../components/ui/inputs';
import { getAllForms } from '../../functions/getAllForms';
import { getFormByIdItemId } from '../../functions/getFormById';

export default function ListForms() {
  const navigate = useNavigate();
  const [isInForce, setIsInForce] = useState(localStorage.getItem("inForce") === "true" ? true : false);
  const clientIdForce = localStorage.getItem("clientIdForce") as string;
  const { authorizationRA, authorizationForce, user, signOut } = useAuthContext();
  const ambient = user?.ambient as string;
  // const clientId = isInForce ? clientIdForce : user?.clientId as string
  const clientId = user?.clientId as string
    ? localStorage.getItem("inForce") === "true"
      ? clientIdForce
      : user?.clientId as string
    : clientIdForce

  const token = localStorage.getItem("inForce") === "true" ? authorizationForce : authorizationRA;
  console.log("authorizationForce", authorizationForce);

  const [allForm, setAllForm] = useState<any[]>([]);
  const [countForms, setCountForms] = useState(0);
  const [loadingPage, setLoadingPage] = useState(false);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  // const [formsExcluded, setFormsExcluded] = useState<string[]>([]);
  const itemsPerPage = 15;
  const [cacheCleared, setCacheCleared] = useState(false);

  // Limpa os caches assim que o componente monta
  useEffect(() => {
    const clearCacheClient = async () => {
      try {
        const cacheKeys = await caches.keys();
        if (cacheKeys.length > 0) {
          await Promise.all(cacheKeys.map(key => caches.delete(key)));
          setCacheCleared(true);
        }
      } catch (error: any) {
        console.error('Erro ao limpar cache:', error);
      }
    };
    clearCacheClient();
  }, []);

  // Função para carregar os formulários conforme o valor de isInForce
  const loadForms = useCallback(async () => {
    await getAllForms(
      setLoadingPage,
      token,
      ambient,
      setAllForm,
      currentPage,
      itemsPerPage,
      setCountForms
    );
  }, [setLoadingPage, token, ambient, setAllForm, currentPage, itemsPerPage, setCountForms, signOut]);

  // Atualiza os formulários sempre que o valor de isInForce mudar
  useEffect(() => {
    loadForms();
  }, [isInForce, loadForms]);

  const handleFormClick = (formId: string) => {
    setSearch('');
    navigate(`/section/updateForm?clientId=${clientId}&formId=${formId}`, { state: { formId } });
  };

  const handleNextPage = () => {
    const totalPages = Math.ceil(countForms / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handleSearchForm = async () => {
    setLoadingPage(true);
    await getFormByIdItemId(clientId, search, ambient, setAllForm, setSearch, signOut);
    setLoadingPage(false);
  };

  return (
    <Flex>
      <Helmet>
        <title>Tech Forms - Listagem dos Formulários</title>
      </Helmet>
      <Flex className={style.container}>
        {loadingPage ? (
          <Flex className={style.spinnerContainer}>
            <FontAwesomeIcon icon={faSpinner} size="2x" style={{ color: "#ffffff" }} spin />
          </Flex>
        ) : (
          <Flex className={style.main}>
            <div className={style.infoInputForm}>
              <div>
                <Flex className={style.inputFormId}>
                  <button
                    title="Página Anterior"
                    className={style.pagination}
                    onClick={handlePreviousPage}
                    disabled={currentPage <= 1}
                  >
                    <FontAwesomeIcon icon={faArrowLeft} size="2x" />
                  </button>
                  <div className={style.divFormId}>
                    <span>Pesquisar</span>
                    <InputsInfosPages
                      placeholder="Id - ItemId - Alias"
                      type="text"
                      value={search}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setSearch(event.target.value)
                      }
                    />
                    <button
                      title="Pesquisar Formulário"
                      onClick={handleSearchForm}
                    >
                      <FontAwesomeIcon className={style.iconSearch} icon={faMagnifyingGlass} />
                    </button>
                  </div>
                  <button
                    title="Próxima Página"
                    className={style.pagination}
                    onClick={handleNextPage}
                    disabled={currentPage >= Math.ceil(countForms / itemsPerPage)}
                  >
                    <FontAwesomeIcon icon={faArrowRight} size="2x" />
                  </button>
                </Flex>
                <div className={style.infoPage}>
                  <span>
                    Página {currentPage} de {Math.ceil(countForms / itemsPerPage)}
                  </span>
                </div>
              </div>
            </div>
            <div className={style.divForm}>
              {allForm.map((form: any) => (
                <div className={style.divFormExcluded} key={form.id}>
                  <div
                    onClick={() => { handleFormClick(form.id); setSearch(''); }}
                    className={style.form}
                  >
                    <div className={style.formRow}>
                      <span className={style['item-title']}>
                        <span className={style.nameItems}>Id: </span>
                        {form.id}
                      </span>
                      <span className={style['item-title']}>
                        <span className={style.nameItems}>Nome: </span>
                        {form.name}
                      </span>
                      <span className={style['item-title']}>
                        <span className={style.nameItems}>Criado em: </span>
                        {format(new Date(form.createdAt), 'dd/MM/yyyy HH:mm', { locale: ptBR })}
                      </span>
                    </div>
                    <div className={style.formRow}>
                      <span className={style['item-title']}>
                        <span className={style.nameItems}>ItemId: </span>
                        {form.itemId}
                      </span>
                      <span className={style['item-title']}>
                        <span className={style.nameItems}>Atualizado em: </span>
                        {format(new Date(form.updatedAt), 'dd/MM/yyyy HH:mm', { locale: ptBR })}
                      </span>
                      <div className={style.divStatus}>
                        <span className={form.status === 'published' ? style.published : style.unpublished}>
                          {form.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}
